function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "broken-link");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home",
  transform: "translate(-256.000000, -119.000000)",
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(249.000000, 113.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "broken-link",
  transform: "translate(7.000000, 6.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.5114587,0 C10.5798274,0 9.70378982,0.362228272 9.04489528,1.01962223 L6.32835858,3.72997221 C6.53597215,3.70105376 6.74338777,3.66965256 6.95561057,3.66965256 C7.54075733,3.66965256 8.11414065,3.78306931 8.64126193,3.99336992 L10.3333606,2.30512491 C10.6483439,1.99128215 11.0665684,1.81816643 11.5114587,1.81816643 C12.4301954,1.81816643 13.1776268,2.56389567 13.1776268,3.48054 C13.1776268,3.92444526 13.004116,4.34168912 12.6895568,4.65595508 L9.64378491,7.69484687 C9.01379,8.3225042 7.91755531,8.32295561 7.2875604,7.69529828 L6,8.98170379 C6.65847037,9.63822314 7.53447973,10 8.46565852,10 C9.39728976,10 10.2732991,9.63777173 10.9322219,8.98037777 L13.9780504,5.94148599 C14.6369449,5.28409203 15,4.41004951 15,3.48054 C15,1.5611731 13.435235,0 11.5114587,0 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.34271306,11.0092086 L4.6665965,12.6871431 C4.35161417,13.0020424 3.93339094,13.175741 3.48850208,13.175741 C2.56976828,13.175741 1.82233917,12.4275012 1.82233917,11.5077709 C1.82233917,11.0623996 1.9958495,10.6437227 2.31040767,10.3283988 L5.35622653,7.27927644 C5.98621946,6.64950608 7.08245071,6.64905315 7.71244364,7.27882351 L9,5.98808727 C7.68263923,4.67062818 5.38560679,4.67020356 4.06779357,5.98941775 L1.02194643,9.03854008 C0.363025685,9.69814718 0,10.5751039 0,11.5077426 C0,13.4335995 1.56473176,15 3.4884738,15 C4.42010211,15 5.29610871,14.6365523 5.95502946,13.9769452 L8.63550389,11.2935635 C8.43979577,11.3198901 8.24510565,11.351397 8.04427932,11.351397 C7.4501139,11.3514253 6.87463986,11.2325029 6.34271306,11.0092086 Z",
  id: "Path"
})))));

var SvgShareLinkCamaron = function SvgShareLinkCamaron(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "15px",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareLinkCamaron, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/share-link-camaron.80408659.svg";
export { ForwardRef as ReactComponent };